var toS = require('./toS')

/**
 * Checks if `value` is classified as a `String` **primitive**.
 *
 * @since 3.0.0
 * @category Lang
 * @memberOf is
 * @param {*} x The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String
 * @see https://github.com/lodash/lodash/blob/master/isString.js
 * @see is/string
 *
 * @example
 *
 * isString('abc')
 * // => true
 *
 * isString(new String('abc'))
 * // => false
 *
 * isString(1)
 * // => false
 */
module.exports = function (x) { return typeof x === 'string'; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyaW5nUHJpbWl0aXZlLmpzIiwic291cmNlcyI6WyJzdHJpbmdQcmltaXRpdmUuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgdG9TID0gcmVxdWlyZSgnLi90b1MnKVxuXG4vKipcbiAqIENoZWNrcyBpZiBgdmFsdWVgIGlzIGNsYXNzaWZpZWQgYXMgYSBgU3RyaW5nYCAqKnByaW1pdGl2ZSoqLlxuICpcbiAqIEBzaW5jZSAzLjAuMFxuICogQGNhdGVnb3J5IExhbmdcbiAqIEBtZW1iZXJPZiBpc1xuICogQHBhcmFtIHsqfSB4IFRoZSB2YWx1ZSB0byBjaGVjay5cbiAqIEByZXR1cm5zIHtib29sZWFufSBSZXR1cm5zIGB0cnVlYCBpZiBgdmFsdWVgIGlzIGEgc3RyaW5nLCBlbHNlIGBmYWxzZWAuXG4gKlxuICogQHNlZSBodHRwczovL2RldmVsb3Blci5tb3ppbGxhLm9yZy9lbi1VUy9kb2NzL1dlYi9KYXZhU2NyaXB0L1JlZmVyZW5jZS9HbG9iYWxfT2JqZWN0cy9TdHJpbmdcbiAqIEBzZWUgaHR0cHM6Ly9naXRodWIuY29tL2xvZGFzaC9sb2Rhc2gvYmxvYi9tYXN0ZXIvaXNTdHJpbmcuanNcbiAqIEBzZWUgaXMvc3RyaW5nXG4gKlxuICogQGV4YW1wbGVcbiAqXG4gKiBpc1N0cmluZygnYWJjJylcbiAqIC8vID0+IHRydWVcbiAqXG4gKiBpc1N0cmluZyhuZXcgU3RyaW5nKCdhYmMnKSlcbiAqIC8vID0+IGZhbHNlXG4gKlxuICogaXNTdHJpbmcoMSlcbiAqIC8vID0+IGZhbHNlXG4gKi9cbm1vZHVsZS5leHBvcnRzID0geCA9PiB0eXBlb2YgeCA9PT0gJ3N0cmluZydcbiJdLCJuYW1lcyI6WyJjb25zdCJdLCJtYXBwaW5ncyI6IkFBQUFBLEdBQUssQ0FBQyxHQUFHLEdBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUEwQjVCLE1BQU0sQ0FBQyxPQUFPLEdBQUcsVUFBQSxDQUFDLENBQUEsQ0FBQyxBQUFHLFNBQUEsT0FBTyxDQUFDLEtBQUssUUFBUSxHQUFBOyJ9